const HOURS_LIMIT = 48;

export { HOURS_LIMIT };
//# sourceMappingURL=hoursLimit.js.map
